module.exports = __webpack_public_path__ + "img/TIMES-CIRCLE.c5b7b4e6.svg";